/**
 * TINT Feed
 * -----------------------------------------------------------------------------
 */

// Imports
const { ALERT_MESSAGES } = require( '../../utilities/_constants' );



const hasTintFeed = document.querySelector( '.share__bg--home' );

if ( hasTintFeed ) {

  try {
  
    import( 'tint_feed_script' )
      .catch( ( e ) => console.log( e ) );

  } catch( e ) {
    alert( ALERT_MESSAGES.DYNAMIC_IMPORTS );
  }

}